import React, { useEffect, useState } from 'react';
import './classess.css';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { registerNewClientLabel, patchClientLabel, getDefaultLabels, getClientLabels } from '../../api/SessionsService';
import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Zoom from '@mui/material/Zoom';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import { AddCircleOutlineOutlined } from '@mui/icons-material';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { setDefaultLabels } from '../../redux/features/app/app';
import { getUserData } from '../../api/UserService';

const tempColours = ['#264653', '#2a9d8f', '#e9c46a', '#f4a261', '#e76f51'];

const AddLabelsButton = () => {
  const dispatch = useAppDispatch();

  const user = useAppSelector((store) => store.app.user);

  const [newLabel, setNewLabel] = useState<string>('');
  const [anchorElAddLabel, setAnchorElAddLabel] = useState<null | HTMLElement>(null);

  const availableLabels = useAppSelector((state) => state.app.defaultLabels);

  const addButtonOpen = Boolean(anchorElAddLabel);
  const addButtonId = addButtonOpen ? 'simple-popper' : undefined;

  const generateColor = () => {
    return tempColours[availableLabels.length % tempColours.length];
  };

  const clickAwayHandler = () => {
    if (anchorElAddLabel) setAnchorElAddLabel(null);
  };

  const addLabelClick = async (event: React.MouseEvent<HTMLElement>) => {
    if (!anchorElAddLabel) {
      const target = event.currentTarget;

      try {
        const { data: userData } = await getUserData();
        const { data } = await getDefaultLabels(userData.id);

        dispatch(setDefaultLabels(data));
        setAnchorElAddLabel(target);
      } catch (error) {}
    } else {
      setAnchorElAddLabel(null);
    }
  };

  const registerNewDefaultLabel = async () => {
    try {
      const { data: userData } = await getUserData();
      const { data } = await getDefaultLabels(userData.id);
      const index = data.findIndex(({ code }) => code === newLabel);

      console.log(data);
      if (index !== -1) {
        await patchClientLabel(data[index].id, { isDefault: true });
        setNewLabel('');
        const { data: newLabels } = await getDefaultLabels(userData.id);
        dispatch(setDefaultLabels(newLabels));
      } else {
        const allLabels = await getClientLabels(newLabel);
        const existingLabel = allLabels.data.filter((label) => label.code === newLabel);

        if (existingLabel.length === 1) {
          await patchClientLabel(existingLabel[0].id, { isDefault: true });
          setNewLabel('');
          const { data: newLabels } = await getDefaultLabels(userData.id);
          dispatch(setDefaultLabels(newLabels));
        } else {
          await registerNewClientLabel(newLabel, generateColor(), true);
          setNewLabel('');
          const { data: newLabels } = await getDefaultLabels(userData.id);
          dispatch(setDefaultLabels(newLabels));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const deleteDefaultLabel = async (id) => {
    try {
      const { data: userData } = await getUserData();
      await patchClientLabel(id, { isDefault: false });
      const { data } = await getDefaultLabels(userData.id);
      dispatch(setDefaultLabels(data));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    //Get default labels
    const wrapper = async () => {
      try {
        const { data: userData } = await getUserData();
        const { data } = await getDefaultLabels(userData.id);
        dispatch(setDefaultLabels(data));
        console.log(data);
      } catch (error) {
        console.log(error);
      }
    };

    wrapper();
  }, []);

  return (
    <>
      <Tooltip title="Dodaj privzete labele" placement="top" arrow disableInteractive>
        <button onClick={addLabelClick}>
          <img src="more.svg" alt="Info svg" style={{ width: 24, height: 24 }} />
        </button>
      </Tooltip>
      <Popper
        id={addButtonId}
        open={addButtonOpen}
        anchorEl={anchorElAddLabel}
        placement="right-end"
        disablePortal={false}
        style={{ zIndex: 100000 }}
        modifiers={[
          {
            name: 'flip',
            enabled: true,
          },
          {
            name: 'preventOverflow',
            enabled: true,
            options: {
              boundariesElement: 'scrollParent',
            },
          },
        ]}
        transition
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={clickAwayHandler}>
            <Zoom {...TransitionProps} timeout={350}>
              <Paper
                elevation={3}
                className="accordion-chip-popper-container roundedcorners paper"
                style={{ marginLeft: '-5px' }}
                square={false}
              >
                <div style={{ maxHeight: 350, overflowY: 'scroll' }}>
                  {availableLabels.map(({ id, code, color, isDefault }) => (
                    <MenuItem key={id} dense className="menuItem" onClick={(e) => e.stopPropagation()} disableRipple>
                      <div className="accordion-chip-popper-dot" style={{ backgroundColor: color }} />
                      {code}

                      <div style={{ flexGrow: 1 }} />
                      <Tooltip title={`Odstrani privzeto labelo '${code}'`}>
                        <IconButton aria-label="delete" onClick={() => deleteDefaultLabel(id)} className="deleteButton">
                          <DeleteOutlinedIcon className="deleteIcon" fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </MenuItem>
                  ))}
                </div>

                <div className="accordion-chip-popper-footer">
                  <AddCircleOutlineOutlined
                    fontSize="small"
                    className="accordion-chip-popper-footer-add"
                    style={{ color: generateColor() }}
                  />
                  <TextField
                    fullWidth
                    placeholder="Vnesi ime labele"
                    value={newLabel}
                    spellCheck={false}
                    onChange={(e) => setNewLabel(e.target.value)}
                    variant="outlined"
                    className="paddingoutline"
                    onKeyPress={(ev) => {
                      if (ev.key === 'Enter') registerNewDefaultLabel();
                    }}
                  />
                </div>
              </Paper>
            </Zoom>
          </ClickAwayListener>
        )}
      </Popper>
    </>
  );
};

export default AddLabelsButton;
